import React, { useEffect, useMemo, useRef, useState } from "react"
import { useMapEvents } from "react-leaflet"
import { ConvertDDToDM, normaliseLng } from "@/utils/geoFormat"

function round(number, precision = 0) {
  return Math.round(number * Math.pow(10, precision) + Number.EPSILON) / Math.pow(10, precision)
}

function MouseCoordinates() {
  const [mousePoint, setMousePoint] = useState(null)
  const formattedCoordinatesRef = useRef("")

  const formattedCoordinates = useMemo(() => {
    if (mousePoint === null) return []
    const [lonFormatted, latFormatted] = ConvertDDToDM([
      normaliseLng(mousePoint.lng),
      mousePoint.lat,
    ])
    return [lonFormatted, latFormatted]
  }, [mousePoint])

  const formattedCoordinatesText = useMemo(
    () => (formattedCoordinates.length > 0 ? formattedCoordinates.join("   ") : ""),
    [formattedCoordinates]
  )

  useEffect(() => {
    formattedCoordinatesRef.current = formattedCoordinatesText
  }, [formattedCoordinatesText])

  useEffect(
    function copyToClipboard() {
      function handleCtrlCKeydown(event) {
        if (event.key === "c" && event.ctrlKey && formattedCoordinatesRef.current && navigator.clipboard) {
          navigator.clipboard.writeText(formattedCoordinatesRef.current)
        }
      }

      document.addEventListener("keydown", handleCtrlCKeydown)

      return function cleanup() {
        document.removeEventListener("keydown", handleCtrlCKeydown)
      }
    },
    []
  )

  useMapEvents({
    mousemove(event) {
      setMousePoint((prev) => {
        if (
          prev &&
          round(prev.lat, 6) === round(event.latlng.lat, 6) &&
          round(prev.lng, 6) === round(event.latlng.lng, 6)
        ) {
          return prev
        }
        return event.latlng
      })
    },
    mouseout() {
      setMousePoint(null)
    },
  })

  if (formattedCoordinates.length === 0) return null
  return (
    <div
      key={"MouseCoordinates inner div"}
      className="leaflet-control-attribution leaflet-control"
      style={{ fontSize: "12px" }}
    >
      {formattedCoordinates.map((coordinate, index) => (
        <span key={index}>
          {coordinate}
          {index === 0 && <>&nbsp;&nbsp;&nbsp;</>}
        </span>
      ))}
    </div>
  )
}

export default MouseCoordinates
